// extracted by mini-css-extract-plugin
export var brand = "_15-9";
export var button = "_15-0";
export var chevron = "_15-v";
export var chevronButton = "_15-w";
export var content = "_15-n";
export var danger = "_15-g";
export var dangerOutlined = "_15-h";
export var dark = "_15-l";
export var darkTheme = "_15-c";
export var extraSmall = "_15-4";
export var fullWidth = "_15-8";
export var ghost = "_15-d";
export var gray = "_15-t";
export var icon = "_15-p";
export var iconButton = "_15-s";
export var iconButtonBorder = "_15-x";
export var iconButtonBorderDark = "_15-y";
export var iconButtonBorderLight = "_15-z";
export var iconLeft = "_15-q";
export var iconRight = "_15-r";
export var large = "_15-1";
export var light = "_15-m";
export var medium = "_15-2";
export var micro = "_15-5";
export var nano = "_15-7";
export var outlined = "_15-k";
export var pending = "_15-a";
export var primary = "_15-i";
export var shadow = "_15-o";
export var small = "_15-3";
export var solidLight = "_15-e";
export var solidLightBrand = "_15-f";
export var spinner = "_15-u";
export var transparent = "_15-j";
export var warning = "_15-b";
export var wideNano = "_15-6";